import { MediaItemCardLocalCombinationBasic } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardLocalCombinationBasic/MediaItemCardLocalCombinationBasic";
import SimpleArticleCardSkeleton from "@coworker/apprestructured/src/shared/simple/SimpleSkeleton/SimpleArticleCardSkeleton";
import { MediaItemCardBasic } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardBasic/MediaItemCardBasic";
import { isLocalCombinationArticle } from "@coworker/app/src/components/RoomSettings/Helpers/articleHelpers";
import { ArticleType } from "@coworker/types/lib/tasks/constants";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import { Article } from "@coworker/app/src/components/RoomSettings/types/article";
import { getMediaItemBadges } from "@coworker/apprestructured/src/media-maintenance/helpers/getMediaItemBadges";
import { useTranslation } from "@coworker/locales";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";

interface ItemListViewItemBasicProps {
  article: AggregatedArticle | Article;
  badges?: ItemBadge[];
  media?: Media;
  itemNo: string;
  canCopyItemNo?: boolean;
}

export const ItemListViewItemBasic = ({
  itemNo,
  badges,
  article,
  media,
  canCopyItemNo = true,
}: ItemListViewItemBasicProps) => {
  const isLocalCombinationItem = isLocalCombinationArticle(
    article?.productArticleType as ArticleType
  );
  const { data: itemInfo, isLoading: isLoadingItemInfo } = useItemInfo(
    isLocalCombinationItem ? "" : itemNo
  );
  const { t } = useTranslation();

  const allBadges = badges ? badges : ([] as ItemBadge[]);
  const additionalBadges = getMediaItemBadges(
    article.id,
    [article.id],
    t,
    false,
    undefined,
    media,
    false
  );
  if (media) {
    allBadges.push(...additionalBadges);
  }
  return (
    <>
      {isLocalCombinationItem && (
        <MediaItemCardLocalCombinationBasic
          article={article}
          canCopyItemNo={canCopyItemNo}
        />
      )}
      {!isLocalCombinationItem && (
        <>
          {isLoadingItemInfo && <SimpleArticleCardSkeleton />}
          {!isLoadingItemInfo && itemInfo && (
            <MediaItemCardBasic
              badges={allBadges}
              item={itemInfo}
              canCopyItemNo={canCopyItemNo}
            />
          )}
        </>
      )}
    </>
  );
};
